module.exports = __webpack_public_path__ + "files/a50367997619f3e990fb4d274bffc2e0.png";